export const english = {
  title: {
    welcome: "Welcome",
    welcomeNext: "Get started in a little steps.",
  },
  signup: {
    name: "Name",
    last_name: "Last name",
    job_position: "Job position",
    country: "Country",
    country_options: {
      MX: "Mexico",
      US: "United States",
    },
    email: "Business email",
    phone: "Phone (Optional)",
    password: "Password",
    repeat_password: "Verify Password",
    company: "Business name",
    website: "Web site",
    terms_agree: "I agree terms & conditions",
    subscribe: "Subscribe NewsLetter",
    register: "Register",
  },
  customPhoneInput: "Set your phone",
};
